import { TalkingPointTemplateType } from './enums/talking-point-template-type.enum';
export const TALKING_POINT_TEMPLATE_TYPE_LABELS = {
    [TalkingPointTemplateType.DONUT]: 'Donut chart',
    [TalkingPointTemplateType.LARGE_VALUE]: 'Number with text',
    [TalkingPointTemplateType.LARGE_VALUE_W_CHART]: 'Number with line chart',
};
